module.exports = {
	"ha": "fha",
	"id": 5.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "62%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "62%",
				"height": "38%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 81.98198198198197,
						"dataLabels": {
							"enabled": true,
							"format": "91",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.47747747747748,
						"dataLabels": {
							"enabled": true,
							"format": "86",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.97297297297297,
						"dataLabels": {
							"enabled": true,
							"format": "81",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.16216216216216,
						"dataLabels": {
							"enabled": true,
							"format": "69",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 48.64864864864865,
						"dataLabels": {
							"enabled": true,
							"format": "54",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 95.83333333333334,
						"dataLabels": {
							"enabled": true,
							"format": "253",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 93.56060606060606,
						"dataLabels": {
							"enabled": true,
							"format": "247",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90.53030303030303,
						"dataLabels": {
							"enabled": true,
							"format": "239",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.43939393939394,
						"dataLabels": {
							"enabled": true,
							"format": "215",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.60606060606061,
						"dataLabels": {
							"enabled": true,
							"format": "160",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.94514767932489,
						"dataLabels": {
							"enabled": true,
							"format": "469",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 93.0379746835443,
						"dataLabels": {
							"enabled": true,
							"format": "441",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90.084388185654,
						"dataLabels": {
							"enabled": true,
							"format": "427",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.53586497890295,
						"dataLabels": {
							"enabled": true,
							"format": "377",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 58.438818565400844,
						"dataLabels": {
							"enabled": true,
							"format": "277",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.86963074604371,
						"dataLabels": {
							"enabled": true,
							"format": "1312",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 95.17709118311983,
						"dataLabels": {
							"enabled": true,
							"format": "1263",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 92.46420497362472,
						"dataLabels": {
							"enabled": true,
							"format": "1227",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.24415975885455,
						"dataLabels": {
							"enabled": true,
							"format": "1171",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.40467219291635,
						"dataLabels": {
							"enabled": true,
							"format": "921",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -18.018018018018022,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.494505494505497,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.813953488372093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.814814814814813,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.739130434782606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.1666666666666625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.371541501976282,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.238866396761131,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.041841004184104,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -25.581395348837212,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.0548523206751037,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.970149253731338,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.1746031746031744,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.709601873536302,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -26.525198938992045,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.130369253956287,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.734756097560976,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.8503562945368155,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.563977180114098,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.349274124679763,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=111"
			},
			{
				"x": 9,
				"text": "30–39<br>n=264"
			},
			{
				"x": 15,
				"text": "40–49<br>n=474"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=1327"
			}
		],
		"dataTable": {
			"< 30": [
				111,
				91,
				86,
				81,
				69,
				54
			],
			"30–39": [
				264,
				253,
				247,
				239,
				215,
				160
			],
			"40–49": [
				474,
				469,
				441,
				427,
				377,
				277
			],
			"≥ 50": [
				1327,
				1312,
				1263,
				1227,
				1171,
				921
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_3.json
// module id = 202
// module chunks = 0